export const DEFAULT_LOCALE = "en-NZ";

export const DEFAULT_CURRENCY = "NZD";
